import { createSlice } from '@reduxjs/toolkit'
const initialState = {
    leftColFilledOut_int: 0,
    rightColFilledOut_int: 0,
    dueDate_int: '',
    dueTime_int: '',
    interpretationTypes_int: [],
    testingSubject_int: '',
    estimatedDurationHrs_int: '',
    estimatedDurationMins_int: '',
    paperWorkChecked_int: '',
    needInterpreterChecked_int: '',
    inPersonMeetingChecked_int: '',
    teleconference_int: '',
    teleconferencePhone_int: '',
    onlineOrVirtChecked_int: '',
    onlineMeetingLink_int: '',
    studentName_int: '',
    phone_int: '',
    grade_int: '',
    gender_int: '',
    languageDropdown_int: '',
    otherLanguages_int: '',
    districtDropdown_int: '',
    schoolDropdown_int: 0,
    address_int: '',
    contactName_int: '',
    contactPhone_int: '',
    contactEmail_int: '',
    approverName_int: '',
    approverPosition_int: '',
    approverEmail_int: '',
    districtRid_int: 0,
    schoolRid_int: 0,
    approverSignatureFile_int: '',
    tableData_int: [],
    notes_int: '',
    coser_int: '',
    progressBar: 0,
    backToInitialValues_int: 0,
    studentDistrictDropdown_int: '',

    docToInterperateFiles_int: [],
};

const interpretationSlice = createSlice({
    name: 'interpretation',
    initialState,
    reducers: {
        dueDate_intUpdated: (state, action) => {
            let dateString = "";
            if (typeof action.payload === "string" || action.payload instanceof Date) {
                let temp = action.payload.toString().substring(0, 10);
                let temp2 = temp.split("-");
                if (temp2.length === 3) {
                    dateString = temp2[0] + "-" + temp2[1] + "-" + temp2[2];
                }
            }
            state.dueDate_int = dateString;
        },
        dueTime_intUpdated: (state, action) => {
            state.dueTime_int = typeof action.payload === "string" ? action.payload : "";
        },
        interpretationTypes_intUpdated: (state, action) => {
            state.interpretationTypes_int = Array.isArray(action.payload)
                ? action.payload
                : typeof action.payload === "string" && action.payload.length > 0
                    ? [action.payload]
                    : [];
        },
        testingSubject_intUpdated: (state, action) => {
            state.testingSubject_int = typeof action.payload === "string" ? action.payload : "";
        },
        estimatedDurationHrs_intUpdated: (state, action) => {
            state.estimatedDurationHrs_int = typeof action.payload === "string" ? action.payload : "";
        },
        estimatedDurationMins_intUpdated: (state, action) => {
            state.estimatedDurationMins_int = typeof action.payload === "string" ? action.payload : "";
        },
        paperWorkChecked_intUpdated: (state, action) => {
            state.paperWorkChecked_int = typeof action.payload === "boolean" ? action.payload : false;
        },
        needInterpreterChecked_intUpdated: (state, action) => {
            state.needInterpreterChecked_int = typeof action.payload === "boolean" ? action.payload : false;
            if (!state.needInterpreterChecked_int){
                state.phone_int = "";
            }
        },
        inPersonMeetingChecked_intUpdated: (state, action) => {
            state.inPersonMeetingChecked_int = typeof action.payload === "boolean" ? action.payload : false;
        },
        teleconference_intUpdated: (state, action) => {
            state.teleconference_int = typeof action.payload === "boolean" ? action.payload : false;
        },
        teleconferencePhone_intUpdated: (state, action) => {
            state.teleconferencePhone_int = typeof action.payload === "string" ? action.payload : "";
        },
        onlineOrVirtChecked_intUpdated: (state, action) => {
            state.onlineOrVirtChecked_int = typeof action.payload === "boolean" ? action.payload : false;
            if (!state.onlineOrVirtChecked_int){
                state.onlineMeetingLink_int = "";
            }
        },
        onlineMeetingLink_intUpdated: (state, action) => {
            state.onlineMeetingLink_int = typeof action.payload === "string" ? action.payload : "";
        },
        studentName_intUpdated: (state, action) => {
            state.studentName_int = typeof action.payload === "string" ? action.payload : "";
        },
        phone_intUpdated: (state, action) => {
            state.phone_int = typeof action.payload === "string" ? action.payload : "";
        },
        grade_intUpdated: (state, action) => {
            state.grade_int = typeof action.payload === "string" ? action.payload : "";
        },
        gender_intUpdated: (state, action) => {
            state.gender_int = typeof action.payload === "string" ? action.payload : "";
        },
        languageDropdown_intUpdated: (state, action) => {
            state.languageDropdown_int = typeof action.payload === "string" ? action.payload : "";
            state.otherLanguages_int = "";
        },
        otherLanguages_intUpdated: (state, action) => {
            state.otherLanguages_int = typeof action.payload === "string" ? action.payload : "";
        },
        districtDropdown_intUpdated: (state, action) => {
            state.districtDropdown_int = typeof action.payload === "string" ? action.payload : "";
            state.schoolDropdown_int = "";
            //state.studentDistrictDropdown_int = "";
        },
        studentDistrictDropdown_intUpdated: (state, action) => {
            state.studentDistrictDropdown_int = typeof action.payload === "string" ? action.payload : "";
        },
        schoolDropdown_intUpdated: (state, action) => {
            state.schoolDropdown_int = typeof action.payload === "string" ? action.payload : "";
        },
        address_intUpdated: (state, action) => {
            state.address_int = typeof action.payload === "string" ? action.payload : "";
        },
        contactName_intUpdated: (state, action) => {
            state.contactName_int = typeof action.payload === "string" ? action.payload : "";
        },
        contactPhone_intUpdated: (state, action) => {
            state.contactPhone_int = typeof action.payload === "string" ? action.payload : "";
        },
        contactEmail_intUpdated: (state, action) => {
            state.contactEmail_int = typeof action.payload === "string" ? action.payload : "";
        },
        approverName_intUpdated: (state, action) => {
            state.approverName_int = typeof action.payload === "string" ? action.payload : "";
        },
        approverPosition_intUpdated: (state, action) => {
            state.approverPosition_int = typeof action.payload === "string" ? action.payload : "";
        },
        approverEmail_intUpdated: (state, action) => {
            state.approverEmail_int = typeof action.payload === "string" ? action.payload : "";
        },
        districtRid_intUpdated: (state, action) => {
            state.districtRid_int = typeof action.payload === "number" ? action.payload : 0;
        },
        schoolRid_intUpdated: (state, action) => {
            state.schoolRid_int = typeof action.payload === "number" ? action.payload : 0;
        },
        approverSignatureFile_intUpdated: (state, action) => {
            state.approverSignatureFile_int = typeof action.payload === "string" ? action.payload : "";
        },
        tableData_intUpdated: (state, action) => {
            state.tableData_int = Array.isArray(action.payload) ? action.payload : [];
        },
        notes_intUpdated: (state, action) => {
            state.notes_int = typeof action.payload === "string" ? action.payload : "";
        },
        coser_intUpdated: (state, action) => {
            state.coser_int = typeof action.payload === "string" ? action.payload : "";
        },

        docToInterperateFiles_intUpdated: (state, action) => {
            state.docToInterperateFiles_int = Array.isArray(action.payload) ? action.payload : [];
        },

        progressBarUpdated: (state, action) => {
            state.progressBar = typeof state.leftColFilledOut_int === "number" && typeof state.rightColFilledOut_int === "number"
                ? state.leftColFilledOut_int + state.rightColFilledOut_int
                : 0;
        },
        leftColFilledOutUpdated_int: (state, action) => {
            let tempVal = 0;

            if (typeof state.dueDate_int === "string" && state.dueDate_int.length > 0){
                tempVal += 8;
            }
            if (typeof state.dueTime_int === "string" && state.dueTime_int.length > 0){
                tempVal += 7;
            }
            if (Array.isArray(state.interpretationTypes_int) && state.interpretationTypes_int.length > 0){
                tempVal += 7;
            }
            if ((Array.isArray(state.interpretationTypes_int) && state.interpretationTypes_int.includes("Testing") && typeof state.testingSubject_int === "string" && state.testingSubject_int.length > 0) || (Array.isArray(state.interpretationTypes_int) && !state.interpretationTypes_int.includes("Testing"))){
                tempVal += 7;
            }
            if ((Array.isArray(state.interpretationTypes_int) && state.interpretationTypes_int.includes("Other") && typeof state.notes_int === "string" && state.notes_int.length > 0) || (Array.isArray(state.interpretationTypes_int) && !state.interpretationTypes_int.includes("Other"))){
                tempVal += 7;
            }
            if ((typeof state.estimatedDurationHrs_int === "string" && state.estimatedDurationHrs_int.length > 0) || (typeof state.estimatedDurationMins_int === "string" && state.estimatedDurationMins_int.length > 0)){
                tempVal += 7;
            }
            if (!state.needInterpreterChecked_int){
                tempVal += 7;
            }
            else if (typeof state.phone_int === "string" && state.phone_int.length > 0 && state.needInterpreterChecked_int){
                tempVal += 7;
            }

            state.leftColFilledOut_int = tempVal;
            state.progressBar = Math.min(state.leftColFilledOut_int + state.rightColFilledOut_int,100);
        },
        rightColFilledOutUpdated_int: (state, action) => {  
             let tempVal = 0;

            if (typeof state.studentName_int === "string" && state.studentName_int.length > 0){
                tempVal += 5;
            }
            if (state.languageDropdown_int == "Other"){
                if (typeof state.otherLanguages_int === "string" && state.otherLanguages_int.length > 0) tempVal += 5;
            }
            else if (typeof state.languageDropdown_int === "string" && state.languageDropdown_int.length > 0 && state.languageDropdown_int != "Other"){
                tempVal += 5;
            }
            if (typeof state.districtDropdown_int === "string" && state.districtDropdown_int.length > 0){
                tempVal += 5;
            }
            if (typeof state.districtDropdown_int === "string" && !state.districtDropdown_int.includes("Nassau BOCES")){
                tempVal += 2;
            }
            else if (typeof state.districtDropdown_int === "string" && state.districtDropdown_int.includes("Nassau BOCES") && typeof state.coser_int === "string" && state.coser_int.length > 0){
                tempVal += 2;
            }
            if (!state.districtDropdown_int.includes("Regional Summer School") && 
                !state.schoolDropdown_int.includes("RSIP")){
                tempVal += 2;
            }
            else if ((state.districtDropdown_int.includes("Regional Summer School") || 
                state.schoolDropdown_int.includes("RSIP")) 
                && state.studentDistrictDropdown_int.length > 0){
                tempVal += 2;
            }
            if (typeof state.schoolDropdown_int === "string" && state.schoolDropdown_int.length > 0){
                tempVal += 5;
            }
            if (typeof state.contactName_int === "string" && state.contactName_int.length > 0){
                tempVal += 5;
            }
            if (typeof state.contactPhone_int === "string" && state.contactPhone_int.length > 0){
                tempVal += 5;
            }
            if (typeof state.contactEmail_int === "string" && state.contactEmail_int.length > 0){
                tempVal += 4;
            }
            if (typeof state.approverName_int === "string" && state.approverName_int.length > 0){
                tempVal += 4;
            }
            if (typeof state.approverPosition_int === "string" && state.approverPosition_int.length > 0){
                tempVal += 4;
            }
            if (typeof state.approverEmail_int === "string" && state.approverEmail_int.length > 0){
                tempVal += 4;
            }

            state.rightColFilledOut_int = tempVal;
            state.progressBar = Math.min(state.leftColFilledOut_int + state.rightColFilledOut_int,100);
        },
        backToInitialValuesUpdated_int: (state, action) => {
            state.leftColFilledOut_int = 0;
            state.rightColFilledOut_int = 0;
            state.dueDate_int = '';
            state.dueTime_int = '';
            state.interpretationTypes_int = [];
            state.testingSubject_int = '';
            state.estimatedDurationHrs_int = '';
            state.estimatedDurationMins_int = '';
            state.paperWorkChecked_int = '';
            state.needInterpreterChecked_int = '';
            state.inPersonMeetingChecked_int = '';
            state.teleconference_int = '';
            state.teleconferencePhone_int = '';
            state.onlineOrVirtChecked_int = '';
            state.onlineMeetingLink_int = '';
            state.studentName_int = '';
            state.phone_int = '';
            state.grade_int = '';
            state.gender_int = '';
            state.languageDropdown_int = '';
            state.otherLanguages_int = '';
            state.districtDropdown_int = '';
            state.schoolDropdown_int = 0;
            state.address_int = '';
            state.contactName_int = '';
            state.contactPhone_int = '';
            state.contactEmail_int = '';
            state.approverName_int = '';
            state.approverPosition_int = '';
            state.approverEmail_int = '';
            state.districtRid_int = 0;
            state.schoolRid_int = 0;
            state.approverSignatureFile_int = '';
            state.tableData_int = [];
            state.notes_int = '';
            state.coser_int = '';
            state.progressBar = 0;
            state.backToInitialValues = 0;
            state.studentDistrictDropdown_int = '';

            state.docToInterperateFiles_int = [];
        },
    },
});

// Export actions directly or leave a placeholder
export const {backToInitialValuesUpdated_int, leftColFilledOutUpdated_int, rightColFilledOutUpdated_int, dueDate_intUpdated, dueTime_intUpdated, interpretationTypes_intUpdated, testingSubject_intUpdated, estimatedDurationHrs_intUpdated, estimatedDurationMins_intUpdated, paperWorkChecked_intUpdated, needInterpreterChecked_intUpdated, inPersonMeetingChecked_intUpdated, teleconference_intUpdated, teleconferencePhone_intUpdated, onlineOrVirtChecked_intUpdated, onlineMeetingLink_intUpdated, studentName_intUpdated, phone_intUpdated, grade_intUpdated, gender_intUpdated, languageDropdown_intUpdated, otherLanguages_intUpdated, districtDropdown_intUpdated, studentDistrictDropdown_intUpdated, schoolDropdown_intUpdated, address_intUpdated, contactName_intUpdated, contactPhone_intUpdated, contactEmail_intUpdated, approverName_intUpdated, approverPosition_intUpdated, approverEmail_intUpdated, districtRid_intUpdated, schoolRid_intUpdated, approverSignatureFile_intUpdated, tableData_intUpdated, notes_intUpdated, coser_intUpdated, docToInterperateFiles_intUpdated} = interpretationSlice.actions;

export default interpretationSlice.reducer;